import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { getTenantFromHost } from "../utils/tenant";

const TenantContext = createContext(null);

export const TenantProvider = ({ children }) => {
  const tenantId = getTenantFromHost();
  const [isUnknownTenant, setIsUnknownTenant] = useState(false);

  useEffect(() => {
    const onTenantNotFound = () => setIsUnknownTenant(true);
    window.addEventListener("tenant-not-found", onTenantNotFound);

    return () => {
      window.removeEventListener("tenant-not-found", onTenantNotFound);
    };
  }, []);

  const value = useMemo(
    () => ({
      tenantId,
      isTenantResolved: Boolean(tenantId),
      isUnknownTenant,
    }),
    [isUnknownTenant, tenantId],
  );

  return (
    <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
  );
};

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error("useTenant must be used within TenantProvider");
  }
  return context;
};
